module.exports = __webpack_public_path__ + "static/media/EyesIcon.c44b5089.svg";